<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina/salta')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/salta/bodega-el-esterco')">Bodega El Esterco</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/salta/bodegas-etchart')">Bodegas Etchart</nuxt-link>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/argentina/salta/finca-quara-winery')">Finca Quara Winery</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Azienda vinicola Finca Quara</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        È risaputo che quando si tratta di vino, l'Argentina è lì con il Sudafrica e la Napa nella migliore posta in gioco del mondo. Eppure dire che è un vino del nuovo mondo è un eufemismo; mentre il regime di Jorge Videla potrebbe aver tenuto nascosto il loro bellissimo Malbec (li voleva senza dubbio per sé) fino agli anni '90, l'industria vinicola argentina ha radici che affondano nel XIX secolo.
                        <br><br>
                        Certamente, negli ultimi 20 anni sono spuntate molte nuove cantine e produttori. Ma questi non devono essere confusi con i produttori tradizionali che sono stati impiantati per anni nell'eccezionale regione di Salta. Finca Quara è uno di questi produttori; potrebbe avere radici nel 19° secolo, ma le prospettive sono molto del 21° secolo.
                    </div>

                    <div class="howto-title2">Casa è dove c'è il vino</div>
                    <div class="howto-text">
                        Costruita sui lotti del XVII secolo appartenenti ai Peñalva Frías, Finca Quara fu fondata da Jose Fortunato, un immigrato libanese. Oggi la tenuta di 140 anni è gestita dalla Familia Felix Lavaque, la quinta generazione di viticoltori familiari. I vigneti di Finca Quara sono tra i più alti della regione e vanno dai 1.600 ai 2.000 metri di altitudine e rappresentano una gamma sorprendente, che comprende vini pregiati di Torrontés, Malbec, Tannat, Cabernet Sauvignon, Merlot, Syrah e Bonarda. Le viti sono irrigate a goccia (un processo illegale in Francia), consentendo l'acqua appena sufficiente affinché le uve concentrino completamente i loro sapori. L'affinamento avviene in botti di rovere.
                    </div>

                    <div class="howto-title2">Un prezzo d'ingresso basso per questa nuova meraviglia del mondo</div>
                    <div class="howto-text">
                        La tenuta è principalmente nota per il suo Malbec molto apprezzato ea basso prezzo, ben al di sotto dello standard della regione (circa € 11 a bottiglia per la selezione speciale da 91 punti). I prezzi sono aumentati di circa il 10% nel periodo di 24 mesi dal secondo trimestre 2017 al secondo trimestre 2019.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Weingut Finca Quara</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es ist eine wohlbekannte Tatsache, dass Argentinien, wenn es um Wein geht, zusammen mit Südafrika und Napa zu den Spitzenreitern der Welt zählt. Doch zu sagen, dass es sich um einen Wein aus der Neuen Welt handelt, ist etwas untertrieben; Während das Regime von Jorge Videla ihren schönen Malbec bis in die 1990er Jahre geheim hielt (er wollte sie zweifellos für sich haben), hat die argentinische Weinindustrie Wurzeln, die bis weit ins 19. Jahrhundert zurückreichen.
                        <br><br>
                        Sicherlich sind in den letzten 20 Jahren viele neue Weingüter und Produzenten entstanden. Diese sind jedoch nicht mit den traditionellen Produzenten zu verwechseln, die seit Jahren in der außergewöhnlichen Region Salta ansässig sind. Finca Quara ist ein solcher Produzent; Es mag seine Wurzeln im 19. Jahrhundert haben, aber die Aussichten sind stark im 21. Jahrhundert verankert.
                    </div>

                    <div class="howto-title2">Zuhause ist dort, wo der Wein ist</div>
                    <div class="howto-text">
                        Die Finca Quara wurde auf den Parzellen der Peñalva Frías aus dem 17. Jahrhundert erbaut und von Jose Fortunato, einem libanesischen Einwanderer, gegründet. Heute wird das 140 Jahre alte Weingut von Familia Felix Lavaque, der fünften Generation von Familienwinzern, geführt. Die Weinberge der Finca Quara gehören zu den höchstgelegenen der Region und reichen von 1.600 bis 2.000 Metern Höhe. Sie bieten eine erstaunliche Vielfalt, darunter hochwertige Weine aus Torrontés, Malbec, Tannat, Cabernet Sauvignon, Merlot, Syrah und Bonarda. Die Reben werden mit Tropfbewässerung bewässert (ein in Frankreich illegales Verfahren), sodass gerade genug Wasser zugeführt wird, damit die Trauben ihre Aromen vollständig konzentrieren können. Die Reifung erfolgt in Eichenfässern.
                    </div>

                    <div class="howto-title2">Ein niedriger Eintrittspreis für dieses neue Weltwunder</div>
                    <div class="howto-text">
                        Das Weingut ist vor allem für seinen hoch bewerteten, preisgünstigen Malbec bekannt, dessen Preis deutlich unter dem Standard der Region liegt (ungefähr 11 € pro Flasche für die 91-Punkte-Spezialauswahl). Die Preise sind im 24-Monats-Zeitraum vom zweiten Quartal 2017 bis zum zweiten Quartal 2019 um etwa 10 % gestiegen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignoble Finca Quara</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        C'est un fait bien connu qu'en matière de vin, l'Argentine est là-haut avec l'Afrique du Sud et Napa dans les meilleurs enjeux du monde. Pourtant, dire que c'est un vin du nouveau monde est un euphémisme; alors que le régime de Jorge Videla a peut-être gardé leur beau Malbec secret (il les voulait sans aucun doute pour lui) jusqu'aux années 1990, l'industrie du vin argentin a des racines qui remontent au XIXe siècle.
                        <br><br>
                        Certes, de nombreux nouveaux établissements vinicoles et producteurs ont vu le jour au cours des 20 dernières années. Mais ceux-ci ne doivent pas être confondus avec les producteurs traditionnels implantés depuis des années dans la région exceptionnelle de Salta. Finca Quara est l'un de ces producteurs ; il a peut-être des racines du XIXe siècle, mais les perspectives sont bien celles du XXIe siècle.
                    </div>

                    <div class="howto-title2">La maison est là où se trouve le vin</div>
                    <div class="howto-text">
                        Construite sur les parcelles du XVIIe siècle appartenant aux Peñalva Frías, la Finca Quara a été fondée par Jose Fortunato, un immigrant libanais. Aujourd'hui, le domaine de 140 ans est dirigé par Familia Felix Lavaque, la cinquième génération de vignerons familiaux. Les vignobles de Finca Quara sont parmi les plus hauts de la région et s'étendent de 1 600 à 2 000 mètres d'altitude et représentent une gamme étonnante, comprenant des vins de valeur de Torrontés, Malbec, Tannat, Cabernet Sauvignon, Merlot, Syrah et Bonarda. Les vignes sont irriguées au goutte-à-goutte (procédé illégal en France), laissant juste assez d'eau pour que les raisins concentrent pleinement leurs arômes. Le vieillissement se fait en fûts de chêne.
                    </div>

                    <div class="howto-title2">Un petit prix d'entrée pour cette nouvelle merveille du monde</div>
                    <div class="howto-text">
                        Le domaine est principalement connu pour son Malbec très bien noté et à bas prix, bien en dessous des standards de la région (environ 11 € la bouteille pour la Sélection Spéciale à 91 points). Les prix ont augmenté d'environ 10 % au cours de la période de 24 mois allant du T2 2017 au T2 2019.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Finca Quara Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        It is a well-known fact that when it comes to wine, Argentina is up there with South Africa and Napa in the world’s best stakes. Yet to say it is a new world wine is a bit of an understatement; while Jorge Videla’s regime may have kept their beautiful Malbec under wraps (he wanted them for himself no doubt) until the 1990s, the Argentina wine industry has roots that go deep into the 19th century.
                        <br><br>
                        Certainly, have been lots of new wineries and producers popping up in the past 20-years. But these are not to be confused with the traditional producers who have been implanted in the exceptional Salta region for years. Finca Quara is one such producer; it might have 19th-century roots but the outlook is very much 21st century.
                    </div>

                    <div class="howto-title2">Home is where the wine is</div>
                    <div class="howto-text">
                        Built on the 17th-century parcels belonging to the Peñalva Frías, Finca Quara was founded by Jose Fortunato, a Lebanese immigrant. Today the 140-year-old estate is run by Familia Felix Lavaque, the fifth generation of family winemakers. Finca Quara’s vineyards are some of the highest in the region and range from 1,600 and 2,000 metres altitude and account for an astonishing range, including value wines from Torrontés, Malbec, Tannat, Cabernet Sauvignon, Merlot, Syrah and Bonarda. The vines are drip-irrigated (a process illegal in France), allowing for just enough water in order for the grapes to fully concentrate their flavours. Ageing takes place in oak barrels.
                    </div>

                    <div class="howto-title2">A low entry price for this new world wonder</div>
                    <div class="howto-text">
                        The estate is mainly known for his highly rated, low priced Malbec, priced well-below standard for the region (approximately €11 a bottle for the 91 point Special Selection). Prices have risen around 10% in the 24-month period from Q2 2017-Q2 2019.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FincaQuaraWinery",
        data () {
            return {
                select: { report: 'Finca Quara Winery', src: '/wine-guide/argentina/salta/finca-quara-winery' },
                items: [
                    { report: 'Bodega El Esterco', src: '/wine-guide/argentina/salta/bodega-el-esterco' },
                    { report: 'Bodegas Etchart', src: '/wine-guide/argentina/salta/bodegas-etchart' },
                    { report: 'Finca Quara Winery', src: '/wine-guide/argentina/salta/finca-quara-winery' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Finca Quara Winery | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Taste the essence of Salta winemaking at its finest with Finca Quara Winery. A leading producer in the Salta wine region, their expertly crafted Malbec, Torrontes, and other varietals showcase the unique terroirs and rich history of the region, located in the high Andes mountains of Argentina. Discover the true flavors of adventure with Finca Quara Winery.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover,
    .wine-guide-country.active {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
